export default "/images/search.svg?5695c4a0165894d5e8ad2546617bf5fb";